import { gql } from 'graphql-tag';

export const getMultiStageReport = gql`
    query getMultiStageReport(
        $itemId: String!
        $itemVersion: String!
        $assignmentId: String!
        $classId: String!
        $transferredClassId: String
    ) {
        getMultiStageReport(
            itemId: $itemId
            itemVersion: $itemVersion
            assignmentId: $assignmentId
            classId: $classId
            transferredClassId: $transferredClassId
        ) {
            studentsReportData {
                firstName
                lastName
                userName
                studentId
                userAssignmentId
                skillDomainData {
                    skillDomainKey
                    noOfCorrect
                    totalQuestionsCount
                    scaleScore
                    placementLevel
                    nationalPercentile
                    skillStrengthTerms
                    skillPreRequisiteTerms
                    skillStretchGoalTerms
                    questions {
                        id
                        assessmentSessionId
                        skillTerms
                    }
                }
                metrics {
                    score
                }
                forecasting {
                    testNameAcronym
                    isDateOfAssessmentPassed
                    probabilitiesMapping {
                        probabilities {
                            key
                            value
                        }
                    }
                }
            }
            overallReportData {
                overallNationalAverage
                overallMinimum
                overallMaximum
                placementLevelMinMaxValues {
                    placementLevelCode
                    minimumValue
                    maximumValue
                }
            }
            framework
            percentileScoreMapping {
                percentiles {
                    key
                    value
                }
            }
            programHierarchy {
                title
                path
            }
            assignedTo
            dueDate
            title
            grade
            studentsNotCompleted {
                firstName
                lastName
                studentId
            }
            assessmentReportingType
            metricsClassAverage
        }
    }
`;
